/**
 * Footer
 * Collapses the footer's link columns below lg, where the design shows them as
 * accordion rows.
 *
 * Direction matters: the columns ship OPEN and are closed here. The reverse
 * would leave the footer empty whenever this never runs.
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $$ } from "@utils/dom";
export const initFooter = () => {
    const columns = $$(".footer__col");
    if (columns.length === 0) {
        return;
    }
    const mobile = window.matchMedia("(max-width: 1023.98px)");
    const sync = () => {
        columns.forEach((column) => {
            column.open = !mobile.matches;
        });
    };
    sync();
    mobile.addEventListener("change", sync);
};
